import { Box, Grid, Typography } from '@mui/material'
import EventTable from '../components/EventTable'
import MarketSnapshot from './MarketSnapshot'
import React, { useContext, useEffect, useRef, useState } from 'react'
import Context from '../Context'
import { apiFetch } from '../utils/api'
import { eventHasArb } from '../utils/arb'
import useInterval from '../utils/useInterval'
import { getSessionId } from '../utils/session'

function Odds({ pollingInterval }) {
  const [ isLoading, setIsLoading ] = useState(false)
  // a poll started before a league change must not paint over the league you moved to
  const requestSeq = useRef(0)
  const [ events, setEvents ] = useState([])
  const { usPrices, showDiscrepancies, currentLeague, minYieldValue, polledHost, setRequestCount, setLastResponseTime, setIsLeagueLoading, isMenuLoading, selectedBookmaker, setSelectedLeague, isFavoriteChanging, selectedEvent, settings, showArbs } = useContext(Context)

  // polling odds
  useInterval(() => {
    if (selectedEvent) {
      return
    }

    if (!isMenuLoading && !isLoading) {
      fetchLeaguesBySport()
    }

    if (isLoading) {
      console.log('isLoading === true')
    }
  }, pollingInterval)

  // first league load
  useEffect(() => {
    const resetAndFetch = async () => {
      console.log('Reset and fetch league!')
      setIsLeagueLoading(true)
      await fetchLeaguesBySport()
      setIsLeagueLoading(false)
    }

    if (!isMenuLoading) {
      resetAndFetch()
    }
    // eslint-disable-next-line
  }, [isMenuLoading, currentLeague, selectedBookmaker, isFavoriteChanging])

  const fetchLeaguesBySport = async () => {
    const seq = ++requestSeq.current
    setIsLoading(true)

    try {
      const { group: currentGroupName, sport: currentSportName, league: currentLeagueName } = currentLeague

      const sessionId = getSessionId()
      const favOnly = (currentGroupName === 'Favorites') ? 'true' : 'false'
      // Only the value bet group filters server side. Arbs must not: the two thresholds are independent,
      // and a high value bet threshold would strip out the very events the arb filter is looking for.
      const minYield = currentGroupName === 'Discrepancies' ? minYieldValue : '-1'
      const sport = (currentSportName) ? `&sport=${currentSportName}` : ''

      const url = `/odds-comparison01?sessionId=${sessionId}&addAll=false&favOnly=${favOnly}&minYield=${minYield}${sport}&bookmaker=${selectedBookmaker}`

      const startTime = Date.now()
      const response = await apiFetch(polledHost, url)
      const endTime = Date.now()

      const data = await response.json()

      if (seq !== requestSeq.current) {
        return
      }

      if (data.length === 0) {
        console.error('emptiness!')
        return
      }

        const timeNow = Date.now()

      if (currentGroupName === 'Favorites') {
        const eventsArr = []

        data.forEach((item) => {
          const { leagues } = item

          leagues.forEach((league) => {
            const { eventList } = league

            eventList.forEach((event) => {
              eventsArr.push(event)
            })
          })
        })

        setSelectedLeague('Favorites')
        setEvents(eventsArr)
        setRequestCount(prevCount => prevCount + 1)
        setLastResponseTime(timeNow)
      } else if (currentGroupName === 'All Sports' || currentGroupName === 'Discrepancies' || currentGroupName === 'Arbs') {
        const currentSport = data.find(el => el.sport === currentSportName)

        if (currentSport) {
          const { leagues } = currentSport

          const currentLeague = leagues.find(el => el.league === currentLeagueName)

          if (currentLeague) {
            const { league, eventList } = currentLeague

            if (eventList.length > 0) {
              setRequestCount(prevCount => prevCount + 1)
              setLastResponseTime(timeNow)
            }

            setSelectedLeague(league)
            setEvents(eventList)
          } else {
            console.error(`Selected league not found! Sport: ${currentSportName}, League: ${currentLeagueName}`)

            setEvents([])

            if (currentGroupName === 'Discrepancies') {
              setRequestCount(prevCount => prevCount + 1)
              setLastResponseTime(timeNow)
            }
          }
        } else {
          console.error(`Selected sport not found! Sport: ${currentSportName}, League: ${currentLeagueName}`)
        }
      }

      console.log(`Processing time: ${endTime - startTime} ms`)
    } catch (error) {
      console.error('Error fetching odds:', error)
    } finally {
      setIsLoading(false)
    }
  }

  // inside a section the highlight is the point of being there, so it does not wait for the toggle
  const highlightValueBets = showDiscrepancies || currentLeague.group === 'Discrepancies'
  const highlightArbs = showArbs || currentLeague.group === 'Arbs'

  const visibleEvents = currentLeague.group === 'Arbs'
    ? events.filter((event) => eventHasArb(event, settings.minArbProfit))
    : events

  const rowsEvents = visibleEvents.sort((a, b) => a.koTime - b.koTime).map((item, index) => {
    return(
      <Grid key={index} item xs={12} sm={12} md={6} lg={6}>
        <EventTable event={item} usPrices={usPrices} showDiscrepancies={highlightValueBets} showArbs={highlightArbs} />
      </Grid>
    )
  })

  if (selectedEvent) {
    return <MarketSnapshot pollingInterval={pollingInterval} />
  }


  return(
    <>
      {
        (rowsEvents.length > 0)
          ? <Box sx={{ flexGrow: 1, flexDirection: 'column', alignItems: 'center' }}>
            <Grid container spacing={2} p={2}>
              {rowsEvents}
            </Grid>
          </Box>
          : <Box p={2} display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="100vh">
            <Typography variant="h3">Empty...</Typography>
          </Box>
      }
    </>
  )
}

export default Odds